import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Dr. Prashanth Vooka",
        "NameLink": "/dr-prashanth-vooka",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D. - Indian Institute of Science Bangalore, India ",
        "AreasofInterest": "Development of Sensor Interfaces, Analog-to-Digital Converters, Measurements, and Instrumentation.",
        "Phone": "0877 250 3250 / 3259",
        "Email": "hod_ee@iittp.ac.in / prashanthv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prashanth.jpg"
    }
]
const Faculty = [


    {
        "Name": "Dr. N N Murty",
        "NameLink": "/dr-n-n-murty",
        "Position": "Professor and Dean (Student Affairs)",
        "Degree": "Ph.D. - IIT Banaras Hindu University, Varanasi, India.",
        "AreasofInterest": "Defect identification and characterization in semiconductors (Diamond, SiC)",
        "Phone": "0877 250 3256",
        "Email": "nnmurty@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/nnmurthy.jpg"
    },
    {
        "Name": "Dr. Rama Krishna Sai Gorthi",
        "NameLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Position": "Professor ",
        "Degree": "Ph.D. - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Signal/Image Processing, Computer Vision and Pattern Recognition & Machine Learning",
        "Phone": "0877 250 3260",
        "Email": "rkg@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SubramanyamSai.JPG"
    },
    {
        "Name": "Dr. Abhishek Kumar Jha",
        "NameLink": "/dr-abhishek-kumar-jha",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "RF and Microwaves, Applied Electromagnetics",
        "Phone": " ",
        "Email": "abhishek.jha@pg.edu.pl",
        "Image": "https://files.iittp.ac.in/images/demo/iit/AKJha.png"
    },
    {
        "Name": "Dr. Parthajit Mohapatra",
        "NameLink": "/dr-parthajit-mohapatra",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Science Bangalore, India",
        "AreasofInterest": "Advanced communication techniques for future wireless networks, Physical Layer Secrecy",
        "Phone": "0877 250 3257",
        "Email": "parthajit@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/parthajitphoto.jpg"
    },
    {
        "Name": "Dr. P. S. SaiKrishna",
        "NameLink": "/dr-sai-krishna",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Industrial Automation, Robust & Optimal Control and Cloud Computing QoS Management",
        "Phone": "0877 250 3261",
        "Email": "psskrishna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/saikrishna1.jpg"
    },
    {
        "Name": "Dr. Subrahmanyam Gorthi",
        "NameLink": "/dr-subrahmanyam-gorthi",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Swiss Federal Institute of Technology, Switzerland",
        "AreasofInterest": "Medical Image Analysis",
        "Phone": "0877 250 3262",
        "Email": "s.gorthi@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/gorti.jpg"
    },
     {
        "Name": "Dr. Swapnil Bhuktare",
        "NameLink": "/dr-swapnil-bhuktare",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Nanoelectronics, Spintronics",
        "Phone": "0877 250 3268",
        "Email": "swapnil@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/swapnil.jpg"
    },
    //{
    //    "Name": "Dr. Prashanth Vooka",
    //    "NameLink": "/dr-prashanth-vooka",
     //   "Position": "Associate Professor",
      //  "Degree": "Ph.D. - Indian Institute of Technology Madras, India",
      //  "AreasofInterest": "Development of Sensor Interfaces, Analog-to-Digital Converters, Measurements, and Instrumentation.",
      //  "Phone": "0877 250 3259",
      //  "Email": "prashanthv@iittp.ac.in",
      //  "Image": "https://files.iittp.ac.in/images/demo/iit/Prashanth.jpg"
   // },
    {
        "Name": "Dr. Vikramkumar Pudi",
        "NameLink": "/dr-vikramkumar-pudi",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Digital Design, Cyber security and Cryptography",
        "Phone": "0877 250 3264",
        "Email": "vikram@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vikram.jpeg"
    },

     {
        "Name": "Dr. Vignesh V",
        "NameLink": "/dr-vignesh-v",
        "Position": "Associate Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "Power System Dynamics, Smart Grids",
        "Phone": "0877 250 3263",
        "Email": "vigneshv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vignesh.jpg"
    },
    

   
     {
         "Name": "Dr. K P Naveen",
         "NameLink": "/dr-k-p-naveen",
         "Position": "Head & Associate Professor",
         "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
         "AreasofInterest": "Performance Analysis of Wireless Networks",
         "Phone": "0877 2503255",
         "Email": "naveenkp@iittp.ac.in",
         "Image": "https://files.iittp.ac.in/images/demo/iit/naveenkp.jpg"
     },
    {
        "Name": "Dr. Imrul Qais",
        "NameLink": "/dr-imrul-qais",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Control Theory, Optimal Control",
        "Phone": " ",
        "Email": "imrulq@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Imrul_Qais_AP.png"
    },
    {
        "Name": "Dr. Pooja Vyavahare",
        "NameLink": "/dr-pooja-vyavahare",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Distributed function computation and optimization, Analysis of communication networks",
        "Phone": "0877 250 3258",
        "Email": "poojav@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/PoojaV.png"
    },
    
    {
        "Name": "Dr. Prateek Kumar Sharma",
        "NameLink": "/dr-prateek-kumar-sharma",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Guwahati, India",
        "AreasofInterest": "High-speed analog and mixed-signal circuits, RF/mm-wave integrated circuits",
        "Phone": "0877 250 3266",
        "Email": "prateek.sharma@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Prateek_Kumar_Sharma_AP.png"
    },
    {
        "Name": "Dr. Ramesh Patel",
        "NameLink": "/dr-ramesh-patel",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Ulsan National Institute of Science and Technology (UNIST), South Korea",
        "AreasofInterest": "Antenna System Architecture for Wireless Communication and Sensing",
        "Phone": "0877 250 3265",
        "Email": "ramesh.patel@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Ramesh_Patel_AP.png"
    },
    
    {
        "Name": "Dr. Sarvendranath Rimalapudi",
        "NameLink": "/dr-sarvendranath-rimalapudi",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Science Bangalore, India",
        "AreasofInterest": "Physical layer wireless communication",
        "Phone": "0877 250 3267",
        "Email": "sarvendranath@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr. Sarvendranath_R.png"
    },
    // {
    //     "Name": "Dr. Shikha Baghel",
    //     "NameLink": "/dr-shikha-baghel",
    //     "Position": "Assistant Professor",
    //     "Degree": "Ph.D. - Indian Institute of Technology Guwahati, India",
    //     "AreasofInterest": "Signal Processing, Speech and Audio Processing",
    //     "Email": "shikhabaghel@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Shikha_Baghel_AP.png"
    // },
    {
        "Name": "Dr. Srujana Kagita",
        "NameLink": "/dr-srujana-kagita",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Delhi, India",
        "AreasofInterest": "Rf And Microwave Components And Antennas",
        "Phone": " ",
        "Email": "srujana.kagita@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/srujana.jpg"
    },

    {
        "Name": "Dr. Vijaya Kumar Gurugubelli",
        "NameLink": "/dr-vijaya-kumar-gurugubelli",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Device Modeling, Power Semiconductor Devices, Nanoelectronics, Sensors",
        "Phone": " ",
        "Email": "vijayg@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Vijaya_Kumar.JPG"
    },
    {
        "Name": "Dr. Viju Nair. R",
        "NameLink": "/dr-viju-nair-r",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Science Bangalore, India",
        "AreasofInterest": "Power Electronics",
        "Phone": "0877 250 3269 ",
        "Email": "vnr@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vnr.jpg"
    }
   




]

const AdjunctFaculty = [

    {
    "Name": "Prof. M. V. Kartikeyan",
    "NameLink": "/dr-m-v-kartikeyan",
    "Position": "Professor (Currently as Director, IIITDM Kancheepuram)",
    "Degree": "Ph.D. - IIT-BHU, Varanasi, India.",
    "AreasofInterest": "High-power Millimeter wave Terahertz Engineering, Sources and Allied Components; RF Circuits (RF-CAS), Antennas and Systems",
    "Phone": "0877 250 3033",
    "Email": "kartik@iittp.ac.in",
    "Image": "https://files.iittp.ac.in/images/demo/iit/profkarthik.jpg"
},
 {
    "Name": "Dr. Rajesh Langoju",
    "NameLink": "#",
    "Position": "Principal Data Scientist, GE Healthcare, Bangalore",
    "Degree": "Ph.D. - Swiss Federal Institute of Technology Lausanne (EPFL), Switzerland",
    "AreasofInterest": "Deep Learning for CT Reconstruction, Inverse Problems for Advanced Imaging Methods, Ultrasonic Imaging, Electrical Impedance Tomography, Optical Tomography, Non-Destructive Imaging, Signal Processing for Biomedical and Industrial Applications.",
    "Phone": " ",
    "Email": "rajesh.langoju@iittp.ac.in",
    "Image": "https://files.iittp.ac.in/images/demo/iit/Rajesh_Langoju.jpg"
},


]


const GuestFaculty = [


   
    {
        "Name": "Lt. Gen. Dr. Anil Kapoor",
        "NameLink": "#",
        "Position": "Professor of Practice, IIT Tirupati",
        "Degree": "Ph.D. - Management from Punjabi University, Patiala",
        "AreasofInterest": "Design Thinking, Industrial Engineering & Automation",
        "Phone": " ",
        "Email": "anilkapoor2012@yahoo.co.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Lt Gen Anil Kapoor.jpg"
    },
    {
        "Name": "Mr. R. Muralidharan",
        "NameLink": "#",
        "Position": "Professor of Practice, IIT Tirupati",
        "Degree": "M.Tech - IIT Bombay",
        "AreasofInterest": "Strategic Systems Engineering",
        "Phone": " ",
        "Email": "r.muralidharan@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Mr_Muralidharan_POP.png"
    },


]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="ELECTRICAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>ELECTRICAL ENGINEERING</h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={5} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p>  <i className='fal fa-graduation-cap me-2' /> {HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                <p > <i className="fal fa-graduation-cap me-2" /> {Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                             {/*--------------------------- Adjunct Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty</h3>
                                {AdjunctFaculty.map((AdjunctFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={AdjunctFaculty.NameLink}>
                                                        <img src={AdjunctFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={AdjunctFaculty.NameLink}>{AdjunctFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{AdjunctFaculty.Position}</p>
                                                    <p className="text-dark">{AdjunctFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {AdjunctFaculty.AreasofInterest}</p>

                                                    {(AdjunctFaculty.Phone !== undefined && AdjunctFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{AdjunctFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {AdjunctFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>



                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Professors of Practice</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4 className='c-link'>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                   <p className="text-dark fw-bold">  <i className='fw-bold text-dark fal fa-graduation-cap me-2' /> {GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span> {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>


                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main